import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M15 18H3V16H15V18ZM21 13H3V11H21V13ZM15 8H3V6H15V8Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "MenuAlt03"
);
